import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/no-webpack-loader-syntax
import videojs from '!video.js';
import './videojs-overlay';
import './videojs-watermark';
import 'video.js/dist/video-js.css';
import { getOS, getPlatform, isIPhone, isPossiblyIPad } from '../../services/os';
import { Capacitor } from '@capacitor/core';
import muvikaAttrs from './../../attrs';
import IosVolumeControl from './../../services/volume';
import MuvikaService from '../../services/muvika';
import TR from '../../Trans';
import { throttle } from '../../services/throttle';
import TopBarPlayer from './TopBarPlayer';
import IntervalService from '../../services/intervals';
import sessionStore from '../../stores/session';
import previewPlayerStore from '../../stores/previewPlayer';
import musicPlayerStore from '../../stores/musicPlayer';
import settingsStore from '../../stores/settings';
import playerStore from '../../stores/player';

const PREVIEW_FADE = 30;

export const DialogPreviewPlayer = (props) => {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const getStreamUrl = previewPlayerStore((state) => state.getStreamUrl);
  const currentTrack = previewPlayerStore((state) => state.currentTrack);
  const streamUrl = previewPlayerStore((state) => state.streamUrl);
  const isMusicPlaying = musicPlayerStore((state) => state.isPlaying);
  const previewStreamUrl = previewPlayerStore((state) => state.previewStreamUrl);
  const setIsPlaying = previewPlayerStore((state) => state.setIsPlaying);
  const isPlaying = previewPlayerStore((state) => state.isPlaying);
  const isPlayerPlaying = playerStore((state) => state.isPlaying);
  const from = previewPlayerStore((state) => state.from);
  const currentVolume = previewPlayerStore((state) => state.currentVolume);
  const isMusicReallyPaused = musicPlayerStore((state) => state.isMusicReallyPaused);
  const isPlayerStopped = playerStore((state) => state.isStopped);
  const isFading = previewPlayerStore((state) => state.isFading);
  const setIsFading = previewPlayerStore((state) => state.setIsFading);
  const settings = settingsStore((state) => state.settings);
  const setVolume = previewPlayerStore((state) => state.setVolume);
  const setCurrentTime = playerStore((state) => state.setCurrentTime);

  const [isVolumeSetFromSettings, setVolumeSetFromSettings] = useState(false);
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const options = props.options;

  const setPlayerVolume = (volume, isSetVolumeFlagFalse = false) => {
    console.log("player volume", volume);
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        IosVolumeControl.setDeviceVolume(volume, isSetVolumeFlagFalse);
      } else {
        player.volume(volume);
      }
      //setVolume(volume);
    }
  };

  const initPlayer = () => {
    const videoElement = document.createElement("video-js");

    videoElement.classList.add('video-js');
    videoRef.current.appendChild(videoElement);
    const player = playerRef.current = videojs(videoElement, options, () => {
    });

    player.bigPlayButton.hide();
    player.controlBar.removeChild(player.controlBar.getChild('PictureInPictureToggle'));

    player.on(['playing'], function () {
      console.log("cover player playing", previewPlayerStore.getState().isPlaying.isPlaying);
      previewPlayerStore.getState().setIsPlaying(true);
    });

    player.on(['pause'], function () {
      console.log("cover player pause", isPlaying.isPlaying);
      //previewPlayerStore.getState().setIsPlaying(false);
      previewPlayerStore.getState().softReset();
    });

    player.fill(true);
    player.playsinline(true);
  };

  useEffect(() => {
    if (!playerRef.current) {
      initPlayer();
    }
  });

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (settings) {
        if (!isVolumeSetFromSettings) {
          if ((!isIPhone() && !isPossiblyIPad()) || Capacitor.isNativePlatform()) {
            if (settings.volume) {
              if (currentVolume.currentVolume == 0) {
                setVolumeSetFromSettings(true);
                setVolume(settings.volume / 100);
                setPlayerVolume(settings.volume / 100);
              }
            }
          } else {
            setPlayerVolume(1);
          }
        }

      }
    }
  }, [settings]);

  const fadeOut = () => {
    const player = playerRef.current;
    if (player) {
      if (!previewPlayerStore.getState().isFading) {
        previewPlayerStore.getState().setIsFading(true);
        console.log("fadeOut");
        let times = 20;
        let volume = previewPlayerStore.getState().currentVolume.currentVolume;
        let reduceBy = volume / times;
        let interval = setInterval(function () {
          if (times > 0) {
            volume = volume - reduceBy;
            setPlayerVolume(volume, times - 1 === 0);
            times = times - 1;
          } else {
            IntervalService.clearMusicFadeOutInterval();
            player.reset();
            previewPlayerStore.getState().softReset();
          }
        }, 100);
        IntervalService.addMusicFadeOutInterval(interval);
      }
    }
  };

  const handleFading = () => {
    const player = playerRef.current;
    if (player) {
      previewPlayerStore.getState().setCurrentTime(player.currentTime())
      if (player.currentTime() > PREVIEW_FADE + parseFloat(previewPlayerStore.getState().currentTrack.audio_start)) {
        fadeOut();
        player.off('timeupdate', handleFading);
      }
    }
  };

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (streamUrl !== "" && previewStreamUrl !== "" && currentTrack) {
        previewPlayerStore.getState().setIsFading(false);
        console.log("cover player streamUrl", streamUrl, previewStreamUrl);
        if (isPlayerPlaying.isPlaying || isMusicPlaying.isPlaying) {
          player.src(previewStreamUrl);
        } else {
          player.src(streamUrl);
        }
        if (settings) {
          if ((!isIPhone() && !isPossiblyIPad()) || Capacitor.isNativePlatform()) {
            if (settings.volume) {
              setVolume(settings.volume / 100);
              setPlayerVolume(settings.volume / 100);
            }
          } else {
            setPlayerVolume(1);
          }
        }
        player.currentTime(currentTrack.audio_start);
        player.off('ended');
        player.one('ended', () => {

        });
        player.off('timeupdate', handleFading);
        player.on('timeupdate', handleFading);
      } else {
        //player.src();
      }
    } else {
      //player.src();
    }
  }, [streamUrl]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      console.log("cover player", isPlaying.isPlaying);
      if (isPlaying.isPlaying) {
        player.play();
      } else {
        player.pause();
      }
    }
  }, [isPlaying]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (isPlaying.isPlaying && isPlayerPlaying.isPlaying) {
        previewPlayerStore.getState().softReset();
      }
    }
  }, [isPlayerPlaying]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (!currentVolume.doNotPropagate) {
        setPlayerVolume(currentVolume.currentVolume);
      }
    }
  }, [currentVolume]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      player.currentTime(from.from);
    }
  }, [from]);

  return (
    <div style={props.style} data-vjs-player>
      <div style={{ height: "100%" }} ref={videoRef} />
    </div>
  );
};

export default DialogPreviewPlayer;